import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'VipTag',
  props: {
    year: {
        type: Number,
        default: -1,
    },
    type: {
        type: Number,
        default: 1,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})